/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sunshine_ExlixirInputs */

const en_sunshine_exlixir = /** @type {(inputs: Sunshine_ExlixirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sunshine Elixir`)
};

const ar_sunshine_exlixir = /** @type {(inputs: Sunshine_ExlixirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اكسير صن شاين`)
};

const de_sunshine_exlixir = /** @type {(inputs: Sunshine_ExlixirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonnenschein-Elixier`)
};

const es_sunshine_exlixir = /** @type {(inputs: Sunshine_ExlixirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elixir de sol`)
};

const fr_sunshine_exlixir = /** @type {(inputs: Sunshine_ExlixirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Élixir de Soleil`)
};

const it_sunshine_exlixir = /** @type {(inputs: Sunshine_ExlixirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elisir del Sole`)
};

const ja_sunshine_exlixir = /** @type {(inputs: Sunshine_ExlixirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サンシャインエリクサー`)
};

const ko_sunshine_exlixir = /** @type {(inputs: Sunshine_ExlixirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선샤인 세럼`)
};

const pt_br_sunshine_exlixir = /** @type {(inputs: Sunshine_ExlixirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elixir Solar`)
};

const ru_sunshine_exlixir = /** @type {(inputs: Sunshine_ExlixirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Солнечный эликсир`)
};

const th_sunshine_exlixir = /** @type {(inputs: Sunshine_ExlixirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`น้ำอมฤตแสงตะวัน`)
};

const tr_sunshine_exlixir = /** @type {(inputs: Sunshine_ExlixirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Günışığı İksiri`)
};

const zh_cn_sunshine_exlixir = /** @type {(inputs: Sunshine_ExlixirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阳光菁华`)
};

const zh_tw_sunshine_exlixir = /** @type {(inputs: Sunshine_ExlixirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`陽光菁華`)
};

/**
* | output |
* | --- |
* | "Sunshine Elixir" |
*
* @param {Sunshine_ExlixirInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const sunshine_exlixir = /** @type {((inputs?: Sunshine_ExlixirInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sunshine_ExlixirInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sunshine_exlixir(inputs)
	if (locale === "ar") return ar_sunshine_exlixir(inputs)
	if (locale === "de") return de_sunshine_exlixir(inputs)
	if (locale === "es") return es_sunshine_exlixir(inputs)
	if (locale === "fr") return fr_sunshine_exlixir(inputs)
	if (locale === "it") return it_sunshine_exlixir(inputs)
	if (locale === "ja") return ja_sunshine_exlixir(inputs)
	if (locale === "ko") return ko_sunshine_exlixir(inputs)
	if (locale === "pt_br") return pt_br_sunshine_exlixir(inputs)
	if (locale === "ru") return ru_sunshine_exlixir(inputs)
	if (locale === "th") return th_sunshine_exlixir(inputs)
	if (locale === "tr") return tr_sunshine_exlixir(inputs)
	if (locale === "zh_cn") return zh_cn_sunshine_exlixir(inputs)
	return zh_tw_sunshine_exlixir(inputs)
});